import { eventManager } from './react-native-message-manager';
import { useEffect } from 'react';

export const useReactNativeMessage = (
  type: string,
  callback: (detail: any) => void,
) => {
  useEffect(() => {
    const unsubscribe = eventManager.subscribe(type, callback);
    return () => unsubscribe();
  }, [type, callback]);
};
